import {
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT_SUCCESS,
  USER_REFRESH_TOKEN_FAIL,
  USER_REFRESH_TOKEN_REQUEST,
  USER_REFRESH_TOKEN_SUCCESS,
} from "../ActionType/loginTypes";
import { api, loginApi } from "../Api/api";

const loginAction = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    });
    const response = await loginApi.post("login", { email, password });
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: USER_LOGIN_SUCCESS,
        payload: data.userInfo,
      });

      getToken(data.token);
      localStorage.setItem("token", data.token);
    } else if (status == 401) {
    
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: [],
      });
    }
  } catch (error) {
      console.log("eroro loadoigi :",error)
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: [],
        error: "Wrong Credentials, Please Try Again...",
      });
    
  }
};

export default loginAction;

export const getToken = (token) => {
  return localStorage.getItem("token") || token;
};

export const expireTokenAction = () => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    await api
      .post("user/expire-tokens", {}, config)
      .then((response) => {
        const { status } = response;
        if (status == 200) {
          // localStorage.removeItem("token");
        } else if (status == 202) {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (error) {}
};

export const logoutAction = () => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    await api
      .post("user/logout", {}, config)
      .then((response) => {
        const { status } = response;
        if (status == 200) {
          dispatch({ type: USER_LOGOUT_SUCCESS });
          localStorage.removeItem("token");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (error) {}
};

export const refreshTokenAction = () => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: USER_REFRESH_TOKEN_REQUEST,
    });
    await api
      .post("user/refresh-tokens", {}, config)
      .then((response) => {
        const { status } = response;
        if (status == 200) {
          localStorage.setItem("token", response.data.refresh);
          // dispatch(getToken(response.data.refresh))
          // dispatch(getUsersAuthAction())
          // dispatch(getUsersAuthAction())
          dispatch({
            type: USER_REFRESH_TOKEN_SUCCESS,
          });
        } else if (status == 202) {
        }
      })
      .catch((error) => {
        dispatch({
          type: USER_REFRESH_TOKEN_FAIL,
        });
        console.log(error);
      });
  } catch (error) {}
};
